import { Component } from 'react'
import ReactGA from 'react-ga'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

class GoogleAnalytics extends Component
{
    static propTypes = {
        history: PropTypes.object.isRequired,
        configuration: PropTypes.object,
        isEnabled: PropTypes.bool.isRequired,
    }

    constructor(props)
    {
        super(props)
        this.trackPageView = this.trackPageView.bind(this)
    }

    componentDidMount()
    {
        const { history, configuration, isEnabled } = this.props

        if(isEnabled === false)
        {
            return
        }

        ReactGA.initialize(configuration.id)

        this.trackPageView(history.location)

        history.listen((location, action) => {
            if(action === 'PUSH')
            {
                this.trackPageView(location)
            }
        })
    }

    trackPageView(location)
    {
        ReactGA.pageview(location.pathname + location.search)
    }

    render()
    {
        return this.props.children
    }
}

export default withRouter(GoogleAnalytics)
